import { Component, OnInit, ViewChild, NgZone, OnDestroy } from '@angular/core';
import { Router } from "@angular/router";
import { Subscription } from 'rxjs';

import { config } from "../../../config/index";
import { SessionStorageService } from '../shared/services/session-storage.service';
import { CartService } from './cart.service';
import { SnackbarService } from "../shared/services/snackbar.service";

import { StripeAddNewPaymentComponent } from '../shared/components/stripe-add-new-payment/stripe-add-new-payment.component';

@Component({
    template: require('./cart.component.html'),
    styles: [require('./cart.component.less')],
    providers: [CartService, SnackbarService],
    preserveWhitespaces: true
})

export class CartComponent implements OnInit, OnDestroy {

    subscriptionData: any = {};
    cardData: any = {};
    priceDetails: any = {};
    loading: boolean = false;
    paymentClicked: boolean = false;

    billingAddress: any = {};
    subscriptionDetails: any = {};
    requiredData: boolean = false;
    validationClassForCountry: any = 'selector';
    validationClassForState: any = 'selector';
    private package = config.package;
    promoCodeAmount: number = 0;
    currency: any;
    shortHeight: boolean = false;

    card: any;
    cardComplete: boolean = false;
    cardDeclined: boolean = false;
    cardDeclinedOnPayment: boolean = false;
    submitClicked: boolean = false;
    disableSubmit: boolean = false;

    zipFormat: any = /\b\d{5}\b/;
    postalFormat: any = /^([a-zA-Z]\d[a-zA-Z]\s\d[a-zA-Z]\d)$/;
    zipError: boolean;
    stateProvinceLabel = 'STATE';

    apiSubscriptions: Subscription[] = [];

    @ViewChild('menubarEvent', { static: false }) menubarEvent: any;
    @ViewChild(StripeAddNewPaymentComponent, { static: false }) stripeAddNewPaymentComponent: any;

    constructor(
        private _router: Router,
        private _cartService: CartService,
        public _mdlSnackbarService: SnackbarService,
        private _sessionStorageService: SessionStorageService,
        private _ngZone: NgZone
    ) { }

    /**
     * function to save api token for login in localforage.
     * @param  {any} data api token.
     */
    saveToken = async (key: string, data: any) => {
        try {
            if (key === "subscription") {
                await this._sessionStorageService.saveItem(this.package, data);
            }
        }
        catch (error) {
            return error;
        }
    }

    fetchCartDetails(res: any) {
        this.subscriptionDetails = res.subscription;
        this.billingAddress = res.billing_address;
        this.currency = config.currency['USD'];
        this.priceDetails = res.amount;
    }

    ngOnInit() {
        document.querySelector('body').style.setProperty("margin-top", "0", "important");
        this.apiSubscriptions.push(this._cartService.getCartDetails()
            .subscribe((res: any) => this.cartDetailsSuccessHandler(res),
                error => this.cartDetailsErrorHandler(error))
        );
    }

    ngAfterContentChecked() {
        this.checkShortHeight();
    }

    checkShortHeight() {
        let el = document.getElementById('payment_container');
        this.shortHeight = el.scrollHeight > el.clientHeight;
    }

    cartDetailsSuccessHandler(res: any) {
        this.fetchCartDetails(res);
    }

    cartDetailsErrorHandler(error: any) {
        this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
    }

    getPaymentIntent() {
        this.submitClicked = true;
        this.disableSubmit = true;
        this.cardDeclinedOnPayment = false;
        this.stripeAddNewPaymentComponent.setUpPaymentIntent('');
    }

    onPaymentIntentStart() {
        this.loading = true;
    }

    onCardSave(data: any) {
        this.subscriptionData = { 'payment_method_id': data.res.id, 'delete_if_failed': true };
        this.apiSubscriptions.push(this._cartService.pay(this.subscriptionData)
            .subscribe((res: any) => this.paySuccessHandler(res),
                error => this.payErrorHandler(error))
        );
    }

    onCardSaveError() {
        this.loading = false;
        this.disableSubmit = false;
        this.paymentClicked = false;
        this.cardDeclined = true;
    }

    onCardValidation(data: any) {
        if (data) {
            this.disableSubmit = false;
            this.loading = false;
        }
    }

    paySuccessHandler(res: any) {
        this.loading = false;
        this.disableSubmit = false;
        this.paymentClicked = false;
        this._sessionStorageService.readItem(config['role']).then(
            (data: any) => {
                if (data) {
                    if (!data.subscription_status || data.subscription_status === "initial_pending") {
                        data.subscription_status = "active";
                    }
                    this._sessionStorageService.saveItem(config['role'], data);
                }
            });
        this.saveToken("subscription", { package: this.subscriptionDetails.package });
        this._router.navigate(['cart-success'], { replaceUrl: true });
    }

    payErrorHandler(error: any) {
        this.loading = false;
        this.disableSubmit = false;
        this.paymentClicked = false;
        this.cardDeclinedOnPayment = true;
        this._mdlSnackbarService.showSnackbar(error.message, 'error');
    }

    ngOnDestroy() {
        document.querySelector('body').style.marginTop = null;
        // unsubscribe all subscriptions
        this.apiSubscriptions.forEach(subscription => subscription?.unsubscribe());
    }
}
